export const getCompleteName = ({
  givenName,
  familyName,
}: {
  givenName?: string;
  familyName?: string;
}) => {
  if (givenName && familyName) {
    return `${givenName} ${familyName}`;
  }
  return givenName || familyName || "";
};
